import http from '@/utils/request';

// 城市额度列表
export const getCityBopList = (data = {}) => {
  const url = '/receipt/ap/city/bopList';
  return http.post({
    url,
    data,
  });
};
// 新增城市额度
export const addCitybop = (data = {}) => {
  const url = '/receipt/ap/city/add';
  return http.post({
    url,
    data,
  });
};
// 编辑城市额度
export const editCitybop = (data = {}) => {
  const url = '/receipt/ap/city/edit';
  return http.post({
    url,
    data,
  });
};
// 城市额度详情
export const getCityDetail = (data = {}) => {
  const url = '/receipt/ap/city/detail';
  return http.post({
    url,
    data,
  });
};
// 城市额度启用停用
export const setCitySwitch = (data = {}) => {
  const url = '/receipt/ap/city/switch';
  return http.post({
    url,
    data,
  });
};


// 客户授信列表
export const getCustBopList = (data = {}) => {
  const url = '/receipt/ap/cust/bopList';
  return http.post({
    url,
    data,
  });
};
// 客户授信启用停用
export const setCustSwitch = (data = {}) => {
  const url = '/receipt/ap/cust/switch';
  return http.post({
    url,
    data,
  });
};
// 客户账单管理-客户额度调整
export const setAdjustQuota = (data = {}) => {
  const url = '/receipt/ap/cust/adjustQuota';
  return http.post({
    url,
    data,
  });
};

// 城市支用查询列表
export const getTradeList = (data = {}) => {
  const url = '/receipt/ap/city/tradeList';
  return http.post({
    url,
    data,
  });
};

// 客户账单管理列表
export const getBillList = (data = {}) => {
  const url = '/receipt/ap/cust/billList';
  return http.post({
    url,
    data,
  });
};
// 客户账单管理-详情（账单明细列表）
export const getBillDetailList = (data = {}) => {
  const url = '/receipt/ap/cust/billDetailList';
  return http.post({
    url,
    data,
  });
};

// 客户账单管理-调账（账单调账列表）
export const getBillAdjustList = (data = {}) => {
  const url = '/receipt/ap/cust/billAdjustList';
  return http.post({
    url,
    data,
  });
};

// 客户账单管理-调账（账单调账操作）
export const setBillAdjust = (data = {}) => {
  const url = '/receipt/ap/cust/billAdjust';
  return http.post({
    url,
    data,
  });
};
